/* eslint-disable react/prop-types */
import React from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
	Alert,
	Snackbar,
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	InputLabel,
	Menu,
	MenuItem,
	Modal,
	Typography,
	useMediaQuery,
	Tooltip,
	TextField,
	InputAdornment,
	Select,
} from '@mui/material';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';

import AddIcon from '@mui/icons-material/Add';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';

import { useTheme } from '@mui/material/styles';

import bundleImg from '../../../../assets/logos/bundlesimg.png';

import hospitalimg from '../../../../assets/logos/locationIcon.png';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
	addLocation,
	getLocation,
	updateLocation,
	getAlllocations,
} from '../../../services/api/apiManager';
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Call, CallSplitRounded } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import MaskedInput from 'react-text-mask';
// const options = ['Edit', 'Delete'];

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'min(820px, calc(100vw - 32px))',
	backgroundColor: '#fff',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

const modalLabelSx = {
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	color: '#0b2450',
	marginBottom: '6px',
};

const modalFieldSx = {
	boxShadow: 'none',
	borderRadius: '6px',
	'& .MuiOutlinedInput-root': {
		minHeight: '42px',
		height: '42px',
		borderRadius: '6px',
		backgroundColor: '#fff',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#0b2450',
		boxShadow: 'none',
		'& fieldset': {
			borderColor: '#d7e3f4',
		},
		'&:hover fieldset': {
			borderColor: '#b8c9e0',
		},
		'&.Mui-focused fieldset': {
			borderColor: '#2f6edb',
			borderWidth: '1px',
		},
	},
	'& .MuiInputBase-input': {
		padding: '10px 12px',
		boxSizing: 'border-box',
	},
};

const modalMaskedInputStyle = {
	width: '100%',
	height: '42px',
	borderRadius: '6px',
	border: '1px solid #d7e3f4',
	padding: '10px 12px',
	boxSizing: 'border-box',
	outlineColor: '#2f6edb',
	fontFamily: 'Poppins',
	fontSize: '13px',
	color: '#0b2450',
	backgroundColor: '#fff',
	boxShadow: 'none',
};

function HospitalList(props) {
	// Using Local-Storage Pratice-ID
	const practice_id = localStorage.getItem('practice_id');

	// Snackbar States
	const [severity, setSeverity] = useState('success'); // Default severity
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [loading, setLoading] = useState(false);
	const [fieldRequiredError, setFieldRequiredError] = useState(false);
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	const schema = Yup.object().shape({
		// Name: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Name: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Type: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		City: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		State: Yup.string().matches(/^[a-zA-Z]+$/, 'Alphabets only'),
		Contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		NPI: Yup.string().matches(/^\d+$/, 'Numbers only '),
		Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});
	const [errors, setErrors] = useState({});
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setLocation((prev) => ({
			...prev,
			[name]: value,
		}));
		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};
	const handleEditModal = (e) => {
		const { name, value } = e.target;
		setEditData((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	const targetEditModal = (event) => {
		event.preventDefault();
		setEditData({
			...editData,
			[event.target.name]: event.target.value,
		});
	};

	const defaultTheme = createTheme();
	const [locations, setLocations] = useState([]);

	const [location, setLocation] = useState({
		Name: '',
		practice_id: practice_id,
		Type: '',
		NPI: '',
		Contact: '',
		Address: '',
		City: '',
		State: '',
		Zip: '',
	});

	// Edit Modal Function States
	const [editValues, setEditValues] = useState({
		Name: '',
		Type: ' ',
		NPI: '',
		Contact: '',
		Address: '',
		City: '',
		State: '',
		Zip: '',
	});

	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	// const handleClose = () => setOpen(false);

	// Edit Modal States
	const [editOpen, setEditOpen] = useState(false);

	// Edit ID State
	const [editData, setEditData] = useState([]);
	const [filterPractice, setFilterPractice] = useState();

	// Delete Data States
	const [deleteID, setDeleteID] = useState();
	const [deleteUser, setDeleteUser] = useState();
	// Dialog State
	const theme = useTheme();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	const [anchorEl, setAnchorEl] = useState(null);

	const [selectedIndex, setSelectedIndex] = useState(null);
	const [searchText, setSearchText] = useState('');
	const [viewMode, setViewMode] = useState('card');
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(9);

	const fetchLocations = async () => {
		setLoading(true);
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				setLocations(response?.data);
				setLoading(false);
			}
		} catch (error) {
			console.error('Error fetching locations:', error);
		}
	};
	const addlocationData = async () => {
		try {
			if (
				!location.Name ||
				!location.NPI ||
				!location.Type ||
				!location.Contact ||
				!location.City ||
				!location.State ||
				!location.Zip
			) {
				setFieldRequiredError(true);
			}
			await schema.validate(location, {
				abortEarly: false,
			});

			const response = await addLocation(location);
			if (response?.status === 201) {
				setLocation(response?.data);
				setOpen(false);
				setLocation({
					Name: '',
					practice_id: practice_id,
					Type: ' ',
					NPI: '',
					Contact: '',
					Address: '',
					City: '',
					State: '',
					Zip: '',
				});
				fetchLocations();
				if (props?.openModalIntialy == 'openModal') {
					props?.renderHandleFromChild('hospital');
				}

				// Open Snackbar Alert
				handleClickSnackbar();
				// Snackbar Color Show
				setSeverity('success');
				// 10 Seconds Show Snackbar
				setTimeout(() => {
					setOpenSnackbar(false);
				}, 1000);
			} else {
				setLocation([]);
			}
		} catch (error) {
			console.error('Error adding locaiton:', error);
		}
	};

	const handleClick = (event, index, data) => {
		setAnchorEl(event.currentTarget);
		// console.log('Index Value: ', index, 'Data: ', data);
		setSelectedIndex(index);
		// handleEditData(data);
	};

	// Function -- Filter Practice Id
	const filterPracticeID = async () => {
		// setFilterPractice([]);
		const filterData = locations?.filter((item) => {
			return item?.practice_id == practice_id;
		});
		setFilterPractice(filterData);
	};

	// Function -- Edit Data
	const handleEditData = (data) => {
		setEditOpen(true); // Open Modal here

		setEditData(data); // Set Practice ID Data
		// console.log( "Each Row Data: ", editData ) ;

		setAnchorEl(null); // when click edit then pop-up remove here
	};

	// Update Modal Values Function -- Edit Function
	const editDataObj = {
		// 'id': editData?.id,
		practice_id: practice_id,
		Name: editData?.Name,
		NPI: editData?.NPI,
		Type: editData?.Type,
		Contact: editData?.Contact,
		Address: editData?.Address,
		City: editData?.City,
		State: editData?.State,
		Zip: editData?.Zip,
	};
	const UpdateModalValues = async (editDataObj) => {
		try {
			// Validate the editDataObj using Yup schema
			await schema.validate(editData, { abortEarly: false });

			// If validation passes, proceed with the updateLocation API call
			const resp = await updateLocation(editData.id, editDataObj);

			if (resp?.request?.status === 200) {
				// Update, Then Close Modal
				setEditOpen(false);
				// Open Snackbar Alert
				handleClickSnackbar();
				// Snackbar Color Show
				setSeverity('info');

				// Fetch new data after successful update
				const newData = await fetchLocations();
				// Close Snackbar after 1 second
				setTimeout(() => {
					setOpenSnackbar(false);
				}, 1000);
			} else {
				// Handle other functionality here
			}
		} catch (error) {
			// Yup validation failed
			// console.error('Yup validation failed:', error);
			// Handle Yup validation error here, such as displaying error messages to the user
		}
	};

	// Dialog Functions Here
	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	// Function For Delete Confirmation Message
	const handleDelete = (deleteData) => {
		setDeleteUser(deleteData?.Name);
		setDeleteID(deleteData?.id);
		setDeletePopupOpen(true);
	};
	// Delete Object
	const deleteStatus = {
		Deleted: true,
	};
	// Function -- Delete Data
	const handleDeleteObj = async (deleteID) => {
		// open pop-up here
		setAnchorEl(null);

		// Delete Function
		const resp = await updateLocation(deleteID, deleteStatus);
		if (resp?.request?.status === 200) {
			setDeletePopupOpen(false);
			// Show Snackbar Alert
			handleClickSnackbar();
			// Snackbar Color Show
			setSeverity('error');
			try {
				const newData = await fetchLocations();
				setTimeout(() => {
					setOpenSnackbar(false);
				}, 2000);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setDeletePopupOpen(false);
		}
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	useEffect(() => {
		fetchLocations();
	}, []); // Call fetchLocations only once

	useEffect(() => {
		filterPracticeID(); // Filter Practice ID
	}, [locations]); // Call filterPracticeID when locations changeview

	const hospitalRows =
		filterPractice?.filter((item) => {
			const search = searchText.trim().toLowerCase();
			if (!search) return true;
			return [
				item?.Name,
				item?.Address,
				item?.City,
				item?.State,
				item?.Zip,
				item?.Type,
			]
				.filter(Boolean)
				.some((value) => value.toString().toLowerCase().includes(search));
		}) || [];

	const paginatedHospitals = hospitalRows.slice(
		page * rowsPerPage,
		page * rowsPerPage + rowsPerPage
	);
	const totalPages = Math.max(1, Math.ceil(hospitalRows.length / rowsPerPage));
	const pageStart = hospitalRows.length === 0 ? 0 : page * rowsPerPage + 1;
	const pageEnd = Math.min((page + 1) * rowsPerPage, hospitalRows.length);

	const formatAddedDate = (item) => {
		const rawDate =
			item?.created_at ||
			item?.CreatedAt ||
			item?.createdAt ||
			item?.DateCreated ||
			item?.dateCreated;

		if (!rawDate) return '-';
		const date = new Date(rawDate);
		if (Number.isNaN(date.getTime())) return rawDate;
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: '2-digit',
			year: 'numeric',
		});
	};

	const getHospitalAddress = (item) =>
		[item?.Address, item?.City, item?.State, item?.Zip].filter(Boolean).join(', ');

	useEffect(() => {
		setPage(0);
	}, [searchText, rowsPerPage]);

	return (
		<ThemeProvider theme={defaultTheme}>
			<Box
				sx={{
					width: '100%',
					background: '#fff',
					border: '1px solid #dce8f5',
					borderRadius: '8px',
					overflow: 'hidden',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: { xs: 'flex-start', sm: 'center' },
						gap: 2,
						flexDirection: { xs: 'column', sm: 'row' },
						p: 2,
						borderBottom: '1px solid #edf2f8',
					}}
				>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
						<Box
							sx={{
								width: 48,
								height: 48,
								borderRadius: '8px',
								background: '#edf4ff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								color: '#2563eb',
								flex: '0 0 auto',
							}}
						>
							<BusinessOutlinedIcon sx={{ fontSize: 30 }} />
						</Box>
						<Box>
							<Typography
								sx={{
									color: '#0b1f42',
									fontFamily: 'Poppins',
									fontSize: '20px',
									fontWeight: 700,
									lineHeight: 1.2,
								}}
							>
								Hospitals
							</Typography>
							<Typography
								sx={{
									color: '#64748b',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 500,
									mt: 0.4,
								}}
							>
								Manage your hospitals and clinic locations
							</Typography>
						</Box>
					</Box>
					<Button
						onClick={handleOpen}
						startIcon={<AddIcon />}
						sx={{
							height: '42px',
							px: 2.4,
							borderRadius: '7px',
							backgroundColor: '#2f6edb',
							color: '#fff',
							fontFamily: 'Poppins',
							fontSize: '13px',
							fontWeight: 700,
							textTransform: 'none',
							boxShadow: '0 4px 10px rgba(47, 110, 219, 0.2)',
							'&:hover': { backgroundColor: '#245fc5' },
						}}
					>
						Add Hospital
					</Button>
				</Box>

				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 2,
						flexWrap: 'wrap',
						p: 2,
					}}
				>
					<TextField
						size="small"
						value={searchText}
						onChange={(event) => setSearchText(event.target.value)}
						placeholder="Search hospital by name, city or state..."
						sx={{
							width: { xs: '100%', sm: 420 },
							'& .MuiOutlinedInput-root': {
								height: '42px',
								borderRadius: '6px',
								fontFamily: 'Poppins',
								fontSize: '13px',
								color: '#0b2450',
								'& fieldset': { borderColor: '#d7e3f4' },
								'&:hover fieldset': { borderColor: '#b8c9df' },
								'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
							},
						}}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon sx={{ color: '#526f9f', fontSize: 22 }} />
								</InputAdornment>
							),
						}}
					/>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								color: '#0b2450',
							}}
						>
							View
						</Typography>
						<Box
							sx={{
								display: 'flex',
								border: '1px solid #d7e3f4',
								borderRadius: '6px',
								overflow: 'hidden',
							}}
						>
							<Button
								onClick={() => setViewMode('card')}
								startIcon={<ViewModuleOutlinedIcon />}
								sx={{
									height: 40,
									borderRadius: 0,
									px: 1.6,
									background: viewMode === 'card' ? '#f1f6ff' : '#fff',
									color: viewMode === 'card' ? '#0f5bca' : '#526072',
									borderRight: '1px solid #d7e3f4',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
								}}
							>
								Card
							</Button>
							<Button
								onClick={() => setViewMode('list')}
								startIcon={<ViewListOutlinedIcon />}
								sx={{
									height: 40,
									borderRadius: 0,
									px: 1.6,
									background: viewMode === 'list' ? '#f1f6ff' : '#fff',
									color: viewMode === 'list' ? '#0f5bca' : '#526072',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
								}}
							>
								List
							</Button>
						</Box>
					</Box>
				</Box>

				{loading ? (
					<BrandedLoader
						title="Loading facilities"
						text="Preparing hospital list"
						minHeight="360px"
					/>
				) : hospitalRows?.length === 0 ? (
					<Box
						width={'100%'}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						minHeight={'360px'}
						color={'#64748b'}
						fontFamily={'Poppins'}
						fontSize={'14px'}
						fontWeight={600}
					>
						No hospitals to display
					</Box>
				) : viewMode === 'card' ? (
					<Grid container spacing={2} sx={{
						px: 2, pb: 2, maxHeight: '400px',
						overflowY: 'auto',
						pr: 1,
					}}>
						{paginatedHospitals?.map((items, index) => {
							const menuIndex = page * rowsPerPage + index;
							return (
								<Grid item xs={12} md={6} xl={4} key={items?.id || menuIndex} >
									<Box
										sx={{
											border: '1px solid #dce8f5',
											borderRadius: '8px',
											background: '#fff',
											overflow: 'hidden',
										}}
									>
										<Box sx={{ display: 'flex', gap: 1.8, p: 2, minHeight: 108 }}>
											<Box
												sx={{
													width: 52,
													height: 52,
													borderRadius: '50%',
													background: '#edf4ff',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													color: '#005cff',
													flex: '0 0 auto',
												}}
											>
												<LocationOnOutlinedIcon sx={{ fontSize: 34 }} />
											</Box>
											<Box sx={{ minWidth: 0, flex: 1 }}>
												<Tooltip title={items?.Name || ''}>
													<Typography
														sx={{
															fontFamily: 'Poppins',
															fontSize: '15px',
															fontWeight: 700,
															color: '#0b1f42',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
														}}
													>
														{items?.Name || '-'}
													</Typography>
												</Tooltip>
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '13px',
														fontWeight: 500,
														color: '#243b63',
														mt: 0.8,
														lineHeight: 1.55,
													}}
												>
													{items?.Address || '-'}
												</Typography>
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '13px',
														fontWeight: 500,
														color: '#243b63',
														lineHeight: 1.55,
													}}
												>
													{[items?.City, items?.State, items?.Zip]
														.filter(Boolean)
														.join(', ') || '-'}
												</Typography>
											</Box>
											<IconButton
												aria-label="more"
												id={`long-button-${menuIndex}`}
												aria-expanded={anchorEl ? 'true' : undefined}
												aria-haspopup="true"
												onClick={(event) => handleClick(event, menuIndex, items)}
												sx={{ width: 34, height: 34, color: '#243b63' }}
											>
												<MoreVertIcon />
											</IconButton>
											<Menu
												id={`long-menu-${menuIndex}`}
												MenuListProps={{
													'aria-labelledby': `long-button-${menuIndex}`,
												}}
												anchorEl={anchorEl}
												open={selectedIndex === menuIndex && Boolean(anchorEl)}
												onClose={handleClose}
												PaperProps={{
													elevation: 0,
													sx: {
														boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
														borderRadius: '8px',
													},
												}}
											>
												<MenuItem sx={{ fontFamily: 'Poppins', fontSize: '13px' }} onClick={() => handleEditData(items)}>
													Edit
												</MenuItem>
												<MenuItem sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#ED2828' }} onClick={() => handleDelete(items)}>
													Delete
												</MenuItem>
											</Menu>
										</Box>
									</Box>
								</Grid>
							);
						})}
					</Grid>
				) : (
					<Box sx={{ px: 2, pb: 2 }}>
						<Box
							sx={{
								border: '1px solid #dce8f5',
								borderRadius: '6px',
								// overflow: 'hidden',
								maxHeight: '400px',   // apni requirement ke hisaab se
								overflowY: 'auto',
								pr: 1, // scrollbar ke liye thoda space
							}}
						>
							<Box
								sx={{
									display: 'grid',
									gridTemplateColumns: '1.4fr 2fr 120px 80px',
									background: '#f3f7fc',
									borderBottom: '1px solid #dce8f5',
									px: 2,
									py: 1.2,
									color: '#233b63',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
								}}
							>
								<Box>Name</Box>
								<Box>Address</Box>
								<Box>Status</Box>
								<Box textAlign="center">Action</Box>
							</Box>
							{paginatedHospitals?.map((items, index) => {
								const menuIndex = page * rowsPerPage + index;
								return (
									<Box
										key={items?.id || menuIndex}
										sx={{
											display: 'grid',
											gridTemplateColumns: '1.4fr 2fr 120px 80px',
											alignItems: 'center',
											px: 2,
											py: 1.3,
											borderBottom: '1px solid #edf2f8',
										}}
									>
										<Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, color: '#0b2450' }}>
											{items?.Name || '-'}
										</Typography>
										<Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: 500, color: '#243b63' }}>
											{getHospitalAddress(items) || '-'}
										</Typography>
										<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
											<Box sx={{ width: 8, height: 8, borderRadius: '50%', background: '#11863b' }} />
											<Typography sx={{ fontFamily: 'Poppins', fontSize: '12px', fontWeight: 600, color: '#116f34' }}>
												Active
											</Typography>
										</Box>
										<Box textAlign="center">
											<IconButton onClick={(event) => handleClick(event, menuIndex, items)} sx={{ width: 34, height: 34, color: '#243b63' }}>
												<MoreVertIcon />
											</IconButton>
											<Menu
												id={`long-list-menu-${menuIndex}`}
												anchorEl={anchorEl}
												open={selectedIndex === menuIndex && Boolean(anchorEl)}
												onClose={handleClose}
												PaperProps={{
													elevation: 0,
													sx: {
														boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
														borderRadius: '8px',
													},
												}}
											>
												<MenuItem sx={{ fontFamily: 'Poppins', fontSize: '13px' }} onClick={() => handleEditData(items)}>
													Edit
												</MenuItem>
												<MenuItem sx={{ fontFamily: 'Poppins', fontSize: '13px', color: '#ED2828' }} onClick={() => handleDelete(items)}>
													Delete
												</MenuItem>
											</Menu>
										</Box>
									</Box>
								);
							})}
						</Box>
					</Box>
				)}

				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						gap: 2,
						flexWrap: 'wrap',
						px: 2,
						py: 1.7,
						borderTop: '1px solid #edf2f8',
					}}
				>
					<Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: 500, color: '#526072' }}>
						Showing {pageStart} to {pageEnd} of {hospitalRows.length} hospitals
					</Typography>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
						<Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, color: '#0b2450' }}>
							Rows per page:
						</Typography>
						<Select
							size="small"
							value={rowsPerPage}
							onChange={(event) => setRowsPerPage(Number(event.target.value))}
							sx={{
								height: 36,
								width: 76,
								borderRadius: '6px',
								fontFamily: 'Poppins',
								fontSize: '13px',
								'& fieldset': { borderColor: '#d7e3f4' },
							}}
						>
							<MenuItem value={6}>6</MenuItem>
							<MenuItem value={9}>9</MenuItem>
							<MenuItem value={12}>12</MenuItem>
						</Select>
						<Typography sx={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, color: '#0b2450' }}>
							{pageStart}-{pageEnd} of {hospitalRows.length}
						</Typography>
						<IconButton
							disabled={page === 0}
							onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
							sx={{ width: 36, height: 36, border: '1px solid #d7e3f4', color: '#526f9f' }}
						>
							<KeyboardArrowLeftIcon />
						</IconButton>
						<Button
							sx={{
								minWidth: 36,
								height: 36,
								borderRadius: '6px',
								background: '#2f6edb',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								'&:hover': { background: '#245fc5' },
							}}
						>
							{page + 1}
						</Button>
						<IconButton
							disabled={page >= totalPages - 1}
							onClick={() => setPage((prev) => Math.min(prev + 1, totalPages - 1))}
							sx={{ width: 36, height: 36, border: '1px solid #d7e3f4', color: '#526f9f' }}
						>
							<KeyboardArrowRightIcon />
						</IconButton>
					</Box>
				</Box>
			</Box>

			{/* Add Hospital*/}

			<Modal
				open={props?.openModalIntialy == 'openModal' ? true : open}
				// onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={{ '& .MuiModal-backdrop': { opacity: '0.75 !important' } }}
			>
				<Box sx={style}>
					<Box
						sx={{
							width: '100%',
							height: '60px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							borderBottom: '1px solid #edf2f8',
							px: 2,
						}}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '20px',
								fontWeight: 700,
								color: '#111827',
							}}
						>
							Add Hospital
						</Typography>
						<IconButton
							onClick={() => {
								setOpen(false);
								setLocation({
									Name: '',
									practice_id: practice_id,
									Type: ' ',
									NPI: '',
									Contact: '',
									Address: '',
									City: '',
									State: '',
									Zip: '',
								});
								setErrors({});
								if (props?.openModalIntialy == 'openModal') {
									props?.renderHandleFromChild('hospital');
								}
							}}
							sx={{ color: '#475569' }}
						>
							<CloseIcon sx={{ fontSize: '22px' }} />
						</IconButton>
					</Box>
					<Grid container spacing={2.2} lg={12} xs={12} md={12} sm={12} sx={{ p: 2.4, maxHeight: 'calc(100vh - 180px)', overflow: 'auto' }}>
						<Grid
							item
							lg={6}
							xs={6}
							md={6}
							sm={6}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Hospital Name<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={fieldRequiredError && location.Name == ''}
								size="small"
								value={location?.Name}
								onChange={handleInputChange}
								name="Name"
								type="text"
								fullWidth
								disableUnderline
								sx={modalFieldSx}
							/>
							{errors.Name && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Name}
								</div>
							)}{' '}
						</Grid>
						<Grid
							item
							lg={6}
							xs={6}
							md={6}
							sm={6}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								NPI<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={fieldRequiredError && location.NPI == ''}
								size="small"
								value={location?.NPI}
								onChange={handleInputChange}
								name="NPI"
								type="text"
								fullWidth
								disableUnderline
								inputProps={{ min: '0' }}
								sx={modalFieldSx}
							/>
							{errors.NPI && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.NPI}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={6} xs={6} md={6} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Type<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={fieldRequiredError && location.Type == ''}
								size="small"
								value={location?.Type}
								onChange={handleInputChange}
								name="Type"
								fullWidth
								disableUnderline
								sx={modalFieldSx}
							/>
							{errors.Type && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Type}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={6} xs={6} md={6} sm={6} sx={{ p: 0 }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Contact<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<MaskedInput
								required
								value={location?.Contact}
								onChange={handleInputChange}
								name="Contact"
								mask={[
									'(',
									/\d/,
									/\d/,
									/\d/,
									')',
									' ',
									/\d/,
									/\d/,
									/\d/,
									'-',
									/\d/,
									/\d/,
									/\d/,
									/\d/,
								]}
								style={{
									...modalMaskedInputStyle,
									border: `${fieldRequiredError && location.Contact == '' ? '1px solid #d61b1b' : '1px solid #d7e3f4'}`,
								}}
							/>
							{errors.Contact && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Contact}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Address
							</InputLabel>
							<TextField
								size="small"
								value={location?.Address}
								onChange={(e) =>
									setLocation((prev) => ({
										...prev,
										Address: e.target.value,
									}))
								}
								name="address"
								type="text"
								fullWidth
								disableUnderline
								sx={modalFieldSx}
							/>
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								City<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={fieldRequiredError && location.City == ''}
								size="small"
								value={location?.City}
								onChange={handleInputChange}
								name="City"
								type="text"
								fullWidth
								disableUnderline
								sx={modalFieldSx}
							/>
							{errors.City && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.City}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								State<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={fieldRequiredError && location.State == ''}
								size="small"
								value={location?.State}
								onChange={handleInputChange}
								name="State"
								type="text"
								fullWidth
								disableUnderline
								sx={modalFieldSx}
							/>
							{errors.State && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.State}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Zip<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={fieldRequiredError && location.Zip == ''}
								size="small"
								value={location?.Zip}
								onChange={handleInputChange}
								name="Zip"
								type="text"
								fullWidth
								disableUnderline
								sx={modalFieldSx}
							/>
							{errors.Zip && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Zip}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Box
							width={'100%'}
							display={'flex'}
							justifyContent={'flex-end'}
							gap={1.5}
							sx={{ pt: 1 }}
						>
							<Button
								onClick={() => {
									setOpen(false);
									setLocation({
										Name: '',
										practice_id: practice_id,
										Type: ' ',
										NPI: '',
										Contact: '',
										Address: '',
										City: '',
										State: '',
										Zip: '',
									});
									setErrors({});
									if (props?.openModalIntialy == 'openModal') {
										props?.renderHandleFromChild('hospital');
									}
								}}
								startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
								sx={{
									minWidth: '124px',
									height: '42px',
									borderRadius: '6px',
									border: '1px solid #cfd9e8',
									color: '#344054',
									backgroundColor: '#fff',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									'&:hover': { backgroundColor: '#f8fafc', borderColor: '#b9c6d8' },
								}}
							>
								Cancel
							</Button>
							<Button
								startIcon={<AddIcon sx={{ fontSize: '18px' }} />}
								sx={{
									minWidth: '140px',
									height: '42px',
									borderRadius: '6px',
									color: '#fff',
									backgroundColor: '#2f6edb',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
									'&:hover': { backgroundColor: '#245fc5' },
								}}
								onClick={() => addlocationData()}
							>
								Add Hospital
							</Button>
						</Box>
					</Grid>
				</Box>
			</Modal>

			{/* Edit Modal */}

			<Modal
				open={editOpen}
				// onClose={editClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={{ '& .MuiModal-backdrop': { opacity: '0.75 !important' } }}
			>
				<Box
					sx={style}
				>
					<Box
						sx={{
							width: '100%',
							height: '60px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							borderBottom: '1px solid #edf2f8',
							px: 2,
						}}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '20px',
								fontWeight: 700,
								color: '#111827',
							}}
						>
							Edit Hospital
						</Typography>
						<IconButton
							onClick={() => {
								setErrors({});
								setEditOpen(false);
							}}
							sx={{ color: '#475569' }}
						>
							<CloseIcon sx={{ fontSize: '22px' }} />
						</IconButton>
					</Box>
					<Grid container spacing={2.2} lg={12} xs={12} md={12} sm={12} sx={{ p: 2.4, maxHeight: 'calc(100vh - 180px)', overflow: 'auto' }}>
						<Grid
							item
							lg={6}
							xs={6}
							md={6}
							sm={6}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Hospital Name<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								size="small"
								name="Name"
								type="text"
								fullWidth
								disableUnderline
								value={editData?.Name}
								onChange={handleEditModal}
								sx={modalFieldSx}
							/>
							{errors.Name && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Name}
								</div>
							)}
						</Grid>
						<Grid
							item
							lg={6}
							xs={6}
							md={6}
							sm={6}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								NPI<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								size="small"
								name="NPI"
								type="text"
								fullWidth
								disableUnderline
								value={editData?.NPI}
								onChange={handleEditModal}
								sx={modalFieldSx}
							/>
							{errors.NPI && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.NPI}
								</div>
							)}
						</Grid>
						<Grid
							item
							lg={6}
							xs={6}
							md={6}
							sm={6}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Type<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								size="small"
								name="Type"
								fullWidth
								disableUnderline
								value={editData?.Type}
								onChange={handleEditModal}
								sx={modalFieldSx}
							/>
							{errors.Type && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Type}
								</div>
							)}
						</Grid>
						<Grid
							item
							lg={6}
							xs={6}
							md={6}
							sm={6}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Contact<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<MaskedInput
								required
								value={editData?.Contact}
								onChange={handleEditModal}
								name="Contact"
								mask={[
									'(',
									/\d/,
									/\d/,
									/\d/,
									')',
									' ',
									/\d/,
									/\d/,
									/\d/,
									'-',
									/\d/,
									/\d/,
									/\d/,
									/\d/,
								]}
								style={modalMaskedInputStyle}
							/>
							{errors.Contact && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Contact}
								</div>
							)}
						</Grid>
						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Address
							</InputLabel>
							<TextField
								size="small"
								name="Address"
								type="text"
								fullWidth
								disableUnderline
								value={editData?.Address}
								onChange={targetEditModal}
								sx={modalFieldSx}
							/>
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								City<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								size="small"
								name="City"
								type="text"
								fullWidth
								disableUnderline
								value={editData?.City}
								onChange={handleEditModal}
								sx={modalFieldSx}
							/>
							{errors.City && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.City}
								</div>
							)}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								State<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								size="small"
								name="State"
								type="text"
								fullWidth
								disableUnderline
								value={editData?.State}
								onChange={handleEditModal}
								sx={modalFieldSx}
							/>
							{errors.State && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.State}
								</div>
							)}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ p: 0 }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Zip<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								size="small"
								name="Zip"
								type="text"
								fullWidth
								disableUnderline
								value={editData?.Zip}
								onChange={handleEditModal}
								sx={modalFieldSx}
							/>
							{errors.Zip && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Zip}
								</div>
							)}
						</Grid>
						<Box
							width={'100%'}
							display={'flex'}
							justifyContent={'flex-end'}
							gap={1.5}
							sx={{ pt: 1 }}
						>
							<Button
								onClick={() => {
									setErrors({});
									setEditOpen(false);
								}}
								startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
								sx={{
									minWidth: '124px',
									height: '42px',
									borderRadius: '6px',
									border: '1px solid #cfd9e8',
									color: '#344054',
									backgroundColor: '#fff',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									'&:hover': { backgroundColor: '#f8fafc', borderColor: '#b9c6d8' },
								}}
							>
								Cancel
							</Button>
							<Button
								disabled={
									errors?.Zip ||
									errors?.Type ||
									errors?.State ||
									errors?.Name ||
									errors?.NPI ||
									errors?.Contact ||
									errors?.City
								}
								startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '18px' }} />}
								sx={{
									minWidth: '132px',
									height: '42px',
									borderRadius: '6px',
									color: '#fff',
									backgroundColor: '#2f6edb',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
									'&:hover': { backgroundColor: '#245fc5' },
									'&.Mui-disabled': {
										backgroundColor: '#d7dce5',
										color: '#98a2b3',
										boxShadow: 'none',
									},
								}}
								onClick={() => UpdateModalValues(editDataObj)}
							>
								Update
							</Button>
						</Box>
					</Grid>
				</Box>
			</Modal>

			{/*Delete Dialog Structure */}

			<Dialog
				fullScreen={fullScreen}
				open={deletePopupOpen}
				onClose={handleDialogClose}
				aria-labelledby="responsive-dialog-title"
				PaperProps={{
					sx: {
						width: 'min(410px, calc(100vw - 32px))',
						borderRadius: '8px',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.22)',
						m: 0,
						overflow: 'hidden',
					},
				}}
			>
				<DialogTitle
					id="responsive-dialog-title"
					sx={{
						width: '100%',
						display: 'flex',
						justifyContent: 'flex-end',
						alignItems: 'center',
						p: '12px 12px 0',
					}}
				>
					<IconButton
						sx={{ width: 32, height: 32, color: '#64748b' }}
						size="small"
						onClick={deleteCancelPopup}
					>
						<CloseIcon sx={{ fontSize: '20px' }} />
					</IconButton>
				</DialogTitle>
				<DialogContent sx={{ p: 0, overflow: 'visible' }}>
					<Box sx={{ px: 3, pt: 1, pb: 3, textAlign: 'center' }}>
						<Box
							sx={{
								width: 74,
								height: 74,
								borderRadius: '50%',
								background: '#fff1f2',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mx: 'auto',
								mb: 2,
							}}
						>
							<Box
								sx={{
									width: 52,
									height: 52,
									borderRadius: '50%',
									background: '#ffe4e6',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<DeleteOutlinedIcon sx={{ color: '#ef4444', fontSize: '30px' }} />
							</Box>
						</Box>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 500,
								fontSize: '15px',
								color: '#1f2937',
								mb: 1,
							}}
						>
							Are you sure you want to delete this hospital?
						</Typography>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '14px',
								color: '#005eff',
								lineHeight: 1.45,
								wordBreak: 'break-word',
							}}
						>
							{deleteUser}
						</Typography>
					</Box>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: '1fr 1fr',
							gap: 1.5,
							px: 3,
							py: 2.5,
							borderTop: '1px solid #edf2f8',
						}}
					>
						<Button
							onClick={deleteCancelPopup}
							startIcon={<CloseIcon sx={{ fontSize: '18px' }} />}
							sx={{
								height: '40px',
								borderRadius: '6px',
								border: '1px solid #d7e3f4',
								background: '#fff',
								color: '#ef4444',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								'&:hover': { background: '#fff5f5', borderColor: '#fecaca' },
							}}
						>
							No
						</Button>
						<Button
							onClick={() => {
								handleDeleteObj(deleteID, deleteStatus);
							}}
							startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '18px' }} />}
							sx={{
								height: '40px',
								borderRadius: '6px',
								background: '#005eff',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: '0 6px 14px rgba(0, 94, 255, 0.24)',
								'&:hover': { background: '#004fd6' },
							}}
						>
							Yes
						</Button>
					</Box>
					{/* <Grid container spacing={2} align="center">
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
							<Button
								style={{ backgroundColor: '#ED2828', width: '75%' }}
								variant="contained"
								size="small"
								autoFocus
								onClick={deleteCancelPopup}
							>
								No
							</Button>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
							<Button
								style={{ backgroundColor: '#FD7702', width: '75%' }}
								variant="contained"
								size="small"
								onClick={() => {
									handleDeleteObj(deleteID, deleteStatus);
								}}
								autoFocus
							>
								Yes
							</Button>
						</Grid>
					</Grid> */}
				</DialogContent>
			</Dialog>

			{/* Show Snackbar After Deletion */}

			<Snackbar
				open={openSnackbar}
				onClose={handleCloseSnackbar}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'center',
				}}
			>
				<Alert
					onClose={handleCloseSnackbar}
					// severity="error"
					severity="success"
					variant="filled"
					sx={{
						width: '100%',
						// height: '4rem',
						textAlign: 'center',
						fontSize: '13px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={() => {
									handleCloseSnackbar();
								}}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '16px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{severity === 'success'
						? 'Hospital Record Added Successfully !'
						: severity === 'info'
							? 'Hospital Record Updated Successfully !'
							: severity === 'error'
								? 'Hospital Record Deleted Successfully !'
								: ''}
				</Alert>
			</Snackbar>
			{/* Fill All Fields Snackbar */}
			<Snackbar
				autoHideDuration={1500}
				open={fieldRequiredError}
				onClose={() => setFieldRequiredError(false)}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'center',
				}}
			>
				<Alert
					onClose={() => setFieldRequiredError(false)}
					severity="error"
					variant="filled"
					sx={{
						width: '100%',
						// height: '4rem',
						textAlign: 'center',
						fontSize: '13px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					Please Fill All Required Fields
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default HospitalList;
